var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"faq"},[_c('h3',[_vm._v("FAQ")]),_c('br'),_vm._l((_vm.faqData),function(q){return _c('FaqItem',{key:q,attrs:{"question":q.q,"answer":q.a}})}),_c('br')],2)])}
var staticRenderFns = []

export { render, staticRenderFns }